/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-20 09:22:10 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 14:04:09
 */

<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Activate Brand(s)</h1>
      <h2>1. How do I activate a brand on Artemis Ads?</h2>
      <p>To activate a brand:</p>
      <ul>
        <li>Log in to your seller account.</li>
        <li>Navigate to the "Brands" section.</li>
        <li>Choose to activate one or multiple brands under your account.</li>
      </ul>
      <p>
        Once activated, you can update your brand’s profile and set up
        commission rates at brand level.
      </p>
      <h2>2. Can I activate multiple brands under one account?</h2>
      <p>Yes!</p>
      <p>
        You can activate and manage multiple brands under a single seller
        account. Each brand will have its own profile and commission rate.
      </p>
      <h2>3. How do I update my brand’s profile?</h2>
      <p>To enhance your brand’s appeal to publishers:</p>
      <ul>
        <li>Go to the "Brands" section in your seller account.</li>
        <li>Upload a professional logo and write a clear, engaging bio.</li>
        <li>Save your changes to update the profile.</li>
      </ul>
      <h2>4. How do I set up commission rates for my brand?</h2>
      <p>You can define commission rates at the brand level:</p>
      <ul>
        <li>Navigate to the "Brands" section.</li>
        <li>Set a default commission rate for the brand.</li>
      </ul>
      <p>You can adjust commission rates for individual products if needed.</p>
      <h2>
        5. Will activating my brand on ArtemisAds affect my brand on Amazon?
      </h2>
      <p>
        <b class="fw600">No</b>, activating your brand on ArtemisAds does not
        affect your brand or products on Amazon. Publishers will only be able to
        view the information you provide on ArtemisAds.
      </p>
      <h2>6. What happens after I activate my brand(s) and products?</h2>
      <p>
        Once your brand(s) and products are activated, publishers can view your
        information and start to promote your brands and products. Make sure
        your brand profile is complete and commission rates are set to attract
        the best opportunities.
      </p>
      <p>Quick Tips for Brand Activation</p>
      <ul>
        <li>
          Activate all relevant brands: Ensure all your brands are activated to
          maximize your campaign reach.
        </li>
        <li>
          Use a professional logo and clear bio: A well-designed logo and
          engaging bio help attract more publishers.
        </li>
        <li>
          Set competitive commission rates: Start with a brand-level rate, and
          adjust for individual products as needed.
        </li>
      </ul>
      <img src="seller/activate-brands.png" alt="ArtemisAds help center">
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>